"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderHistoryColumns = void 0;
function OrderHistoryColumns() {
    return [
        {
            field: 'from_company_name',
            headerName: 'Lieferant',
            editable: false,
            maxWidth: 100,
            type: 'derivedColumn',
        },
        {
            field: 'to_company_name',
            headerName: 'Besteller',
            editable: false,
            maxWidth: 125,
            type: 'derivedColumn',
        },
        {
            field: 'botanisch',
            headerName: 'Botanisch',
            editable: false,
            minWidth: 300,
            type: 'derivedColumn',
        },
        {
            field: 'tb',
            editable: false,
            headerName: 'Tb',
            maxWidth: 75,
            type: 'derivedColumn',
        },
        {
            field: 'pg',
            editable: false,
            headerName: 'PG',
            maxWidth: 75,
            type: 'derivedColumn',
        },
        {
            field: 'ean',
            headerName: 'EAN',
            editable: false,
            maxWidth: 130,
            type: 'derivedColumn',
        },
        {
            field: 'interne_art_nr',
            headerName: 'Interne Art.-Nr.',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'be_art_nr',
            headerName: 'BE-Art.-Nr.',
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'floramedia_art_nr',
            headerName: 'FAN',
            headerTooltip: 'Floramedia Artikel Nummer',
            editable: false,
            maxWidth: 130,
            type: 'derivedColumn',
        },
        {
            field: 'quantity',
            editable: false,
            headerName: 'Bestellmenge',
            type: 'derivedColumn',
        },
        {
            field: 'filled_quantity',
            editable: false,
            headerName: 'Erhalten',
            type: 'derivedColumn',
        },
    ];
}
exports.OrderHistoryColumns = OrderHistoryColumns;
